import * as React from 'react';
import {
    BodyMediumRegular,
    ChevronDownIcon,
    Icon,
    XStack,
    YStack,
} from 'smoothie';

import { PaycheckRoutingRuleNames } from '../../../../../types/PaycheckRouting';
import PaycheckRoutingCard from '../../../common/PaycheckRoutingCard';

interface RuleTypeProps {
    selectedRuleType: string | null;
    openSelect: () => void;
}

const PrimaryRuleType = ({ selectedRuleType, openSelect }: RuleTypeProps) => {
    return (
        <YStack gap={8}>
            <PaycheckRoutingCard onPress={openSelect}>
                <XStack justifyContent="space-between" alignItems="center">
                    <BodyMediumRegular
                        color={
                            selectedRuleType !== null ? '$black' : '$gray800'
                        }
                    >
                        {PaycheckRoutingRuleNames[selectedRuleType ?? ''] ??
                            'Select rule type'}
                    </BodyMediumRegular>
                    <Icon icon={ChevronDownIcon} color="$gray1000" />
                </XStack>
            </PaycheckRoutingCard>
        </YStack>
    );
};

export default PrimaryRuleType;
